import React from "react";
import { Shield, SlidersHorizontal } from "lucide-react";
import { SiKubernetes } from "react-icons/si";
import "../../components/v2components/Cloud/CloudStatus.css";

const roleFilters = [
  { key: "all", label: "All" },
  { key: "default", label: "Default" },
  { key: "custom", label: "Custom" },
];

const resourceRoleFilters = {
  aws: [
    { key: "virtual_machine", label: "EC2 Instances" },
    { key: "storage", label: "S3 Buckets" },
    { key: "database", label: "RDS Databases" },
    { key: "kubernetes", label: "Kubernetes" },
  ],
  azure: [
    { key: "virtual_machine", label: "Virtual Machines" },
    { key: "storage", label: "Storages" },
    { key: "database", label: "Databases" },
    { key: "kubernetes", label: "Kubernetes" },
  ],
  gcp: [
    { key: "virtual_machine", label: "Virtual Machines" },
    { key: "storage", label: "Storages" },
    { key: "database", label: "Databases" },
    { key: "kubernetes", label: "Kubernetes" },
  ],
};

const runtimeTabs = [
  { key: "Roles", label: "Cloud Roles", icon: Shield },
  { key: "K8", label: "Kubernetes Roles", icon: SiKubernetes },
];

export default function CloudRoleSelectorBar({
  roleFilter,
  onRoleFilterChange,
  activeTab,
  onTabChange,
  cloudProvider,
}) {
  const provider = cloudProvider?.toLowerCase();
  const filters = [
    ...roleFilters,
    ...(resourceRoleFilters[provider] || []),
  ];

  return (
    <div className="cloud-card-surface cloud-role-selector bg-card border-border/50 overflow-hidden rounded-2xl">
      <div className="flex flex-col md:flex-row md:items-start justify-between p-3 gap-3">
        <div className="flex min-w-0 flex-1 items-center">
          <div className="cs-tabs !m-0 !w-full flex-wrap !bg-transparent">
            {filters.map((filter) => (
              <button
                key={filter.key}
                onClick={() => {
                  onRoleFilterChange(filter.key);
                  if (activeTab !== "Roles") onTabChange("Roles");
                }}
                className={`cs-tab whitespace-nowrap ${
                  activeTab === "Roles" && roleFilter === filter.key ? "active" : ""
                }`}
                type="button"
              >
                <SlidersHorizontal className="w-4 h-4" />
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex shrink-0 items-center">
          <div className="cs-tabs !m-0 !w-auto !bg-transparent">
            {runtimeTabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.key}
                  onClick={() => onTabChange(tab.key)}
                  className={`cs-tab whitespace-nowrap ${activeTab === tab.key ? "active" : ""}`}
                  type="button"
                >
                  <Icon className="h-4 w-4 shrink-0" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
